module.exports = __webpack_public_path__ + "media/SOC/DNA-d2a30892.svg";